"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.webSite = exports.webPage = exports.video = exports.searchResultsPage = exports.realEstateAgent = exports.postalAddress = exports.place = exports.person = exports.newsArticle = exports.geoCoordinates = exports.event = exports.collectionPage = exports.brand = exports.article = void 0;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var brand = _ref => {
  var {
    logo,
    name
  } = _ref;
  return {
    '@type': 'Brand',
    name,
    logo
  };
};
exports.brand = brand;
var video = _ref2 => {
  var {
    description,
    name,
    thumbnailUrl,
    uploadDate,
    url
  } = _ref2;
  return {
    '@type': 'VideoObject',
    url,
    name,
    description,
    thumbnailUrl,
    uploadDate
  };
};
exports.video = video;
var geoCoordinates = _ref3 => {
  var {
    latitude,
    longitude
  } = _ref3;
  return {
    '@type': 'GeoCoordinates',
    latitude,
    longitude
  };
};
exports.geoCoordinates = geoCoordinates;
var postalAddress = data => {
  var {
    addressCountry,
    addressLocality,
    addressRegion,
    name,
    postalCode,
    postOfficeBoxNumber,
    streetAddress
  } = data;
  return {
    '@type': 'PostalAddress',
    name,
    addressCountry,
    addressLocality,
    addressRegion,
    postOfficeBoxNumber,
    postalCode,
    streetAddress
  };
};
exports.postalAddress = postalAddress;
var place = function (data) {
  var residence = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var {
    address,
    description,
    event,
    geo,
    id,
    image,
    name,
    url
  } = data;
  return {
    '@type': residence ? 'Residence' : 'Place',
    '@id': id,
    name,
    description,
    image,
    address,
    geo,
    event,
    url
  };
};
exports.place = place;
var event = data => {
  var {
    description,
    doorTime,
    endDate,
    eventStatus = 'EventScheduled',
    image,
    location = {},
    name,
    startDate,
    url
  } = data;
  return {
    '@type': 'Event',
    name,
    eventStatus,
    description,
    startDate,
    doorTime,
    endDate,
    image,
    url,
    location
  };
};
exports.event = event;
var realEstateAgent = data => {
  var {
    address,
    areaServed,
    brand: _brand,
    description,
    email,
    faxNumber,
    geo,
    image,
    name,
    sameAs,
    telephone,
    url
  } = data;
  return {
    '@type': 'RealEstateAgent',
    name,
    address,
    geo,
    email: email && "mailto:".concat(email),
    faxNumber,
    telephone,
    brand: _brand,
    areaServed,
    image,
    sameAs,
    url,
    description
  };
};
exports.realEstateAgent = realEstateAgent;
var person = data => {
  var {
    description,
    email,
    familyName,
    faxNumber,
    givenName,
    image,
    jobTitle,
    name,
    sameAs,
    telephone,
    url
  } = data;
  return {
    '@type': 'Person',
    name,
    givenName,
    familyName,
    telephone,
    faxNumber,
    email: email && "mailto:".concat(email),
    jobTitle,
    image,
    sameAs,
    description,
    url
  };
};
exports.person = person;
var article = data => {
  var {
    articleBody,
    articleSection,
    dateModified,
    datePublished,
    headline,
    image,
    url
  } = data;
  return {
    '@type': 'Article',
    headline,
    articleBody,
    articleSection,
    url,
    image,
    datePublished,
    dateModified
  };
};
exports.article = article;
var newsArticle = data => ({
  ...article(data),
  '@type': 'NewsArticle'
});
exports.newsArticle = newsArticle;
var webSite = data => {
  var {
    about,
    description,
    headline,
    image,
    keywords,
    name,
    url
  } = data;
  return {
    '@type': 'WebSite',
    about,
    headline,
    keywords: (0, _isArray.default)(keywords) ? keywords.join(',') : keywords,
    name,
    image,
    description,
    url
  };
};
exports.webSite = webSite;
var webPage = data => {
  var {
    about,
    description,
    image,
    name,
    url
  } = data;
  return {
    '@type': 'WebPage',
    name,
    description,
    about,
    image,
    url
  };
};
exports.webPage = webPage;
var searchResultsPage = data => ({
  ...webPage(data),
  '@type': 'SearchResultsPage'
});
exports.searchResultsPage = searchResultsPage;
var collectionPage = data => ({
  ...webPage(data),
  '@type': 'CollectionPage'
});
exports.collectionPage = collectionPage;